
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrarFuncionariosRoutingModule } from './administrar-funcionarios-routing.module';
import { AdministrarFuncionariosComponent } from './administrar-funcionarios.component';
import { ConsultaFuncionarioComponent } from './consulta-funcionarios/consulta-funcionario.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { InformacionVinculacionComponent } from './informacion-vinculacion/informacion-vinculacion.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from '../../rol/rol.module';
import { HttpClient } from '@angular/common/http';
import { InformacionPersonalComponent } from './informacion-personal/informacion-personal.component';
import { InformacionContactoComponent } from './informacion-contacto/informacion-contacto.component';
import { InformacionSaludPensionComponent } from './informacion-salud-pension/informacion-salud-pension.component';
import { InformacionContratoComponent } from './informacion-contrato/informacion-contrato.component';
import { InformacionJefeComponent } from './informacion-jefe/informacion-jefe.component';
import { RegistrarVehiculoComponent } from './registrar-vehiculos/registrar-vehiculos.component';
import { ModalRegistrarVehiculoComponent } from './registrar-vehiculos/modal-registrar-vehiculo.component';

@NgModule({
    declarations: [AdministrarFuncionariosComponent, ConsultaFuncionarioComponent, RegistrarVehiculoComponent,
        InformacionVinculacionComponent, InformacionPersonalComponent, InformacionContactoComponent,
        InformacionSaludPensionComponent, InformacionContratoComponent, InformacionJefeComponent, 
        ModalRegistrarVehiculoComponent],
    imports: [
        AdministrarFuncionariosRoutingModule,
      SharedModule,
      CommonModule,
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        },
        isolate: true
      })
    ],
    entryComponents: [ModalRegistrarVehiculoComponent]
  })
export class AdministrarFuncionariosModule { }
